<template>
    <div :class="['button-checkbox', modify]">
        <input
            type="checkbox"
            :id="name"
            :name="name"
            :checked="checked"
            :disabled="disabled"
            class="button-checkbox__input"
        >
        <label class="button-checkbox__label" :for="name">
            <span class="button-checkbox__text">{{ value }}</span>
        </label>
    </div>
</template>

<script>
export default {props: ['modify', 'name', 'value', 'checked', 'disabled']};
</script>
